import { createContext, Dispatch, SetStateAction } from 'react';

export interface AuthContextType {
	authorized: boolean;
	logout: () => void;
	isShowAuthPage: boolean;
	setIsShowAuthPage: Dispatch<SetStateAction<boolean>>;
}

export const AuthContext = createContext<AuthContextType>({
	authorized: false,
	logout: () => undefined,
	isShowAuthPage: false,
	setIsShowAuthPage: () => {},
});
